import { render, staticRenderFns } from "./index.vue?vue&type=template&id=baf8a79c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=baf8a79c&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\lptni\\开发\\dev\\project\\unbox-server\\vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('baf8a79c')) {
      api.createRecord('baf8a79c', component.options)
    } else {
      api.reload('baf8a79c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=baf8a79c", function () {
      api.rerender('baf8a79c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/memberFollw/list/index.vue"
export default component.exports